<template>
  <div class="hello">

      <!-- Sending emails -->
        <transition name="fade">
            <div v-if="performingRequest" class="loading">
                <p>Sending emails...</p>
            </div>
        </transition>

      <!-- Preview modal -->
        <b-modal no-fade id='modal-preview' size='xl' title="Email Preview" ok-only header-bg-variant='info' header-text-variant="light">
            <div v-html="createHTMLEmail"></div>
        </b-modal>

        <!-- Error modal -->
        <b-modal no-fade id='modal-senderror' title="Error" ok-only header-bg-variant='info' header-text-variant="light">
            There was an error sending the emails. Please try again later.
        </b-modal>

      <!-- Modal to show no subject error -->
        <b-modal no-fade id='modal-nosubject' title="Missing Email Subject" ok-only header-bg-variant='info' header-text-variant="light">
            Please enter a subject for this email
        </b-modal>

        <!-- Modal to show no text error -->
        <b-modal no-fade id='modal-nocontent' title="Missing Email Content" ok-only header-bg-variant='info' header-text-variant="light">
            Please enter at least 50 characters in this email
        </b-modal>

        <!-- No users selected error -->
        <b-modal no-fade id='modal-nousers' title="No Buyers Selected" ok-only header-bg-variant='info' header-text-variant="light">
            Must select at least one buyer
        </b-modal>

        <!-- Modal to show email sent -->
        <b-modal no-fade id='modal-emailsent' title="Email sent" ok-only header-bg-variant='info' header-text-variant="light"
            @ok="emailSent()">
            Your email has been sent
        </b-modal>

    <b-container>
        

        <b-row style="margin-top:20px; margin-bottom:10px">
            <b-col>
                <h4>Send email to all buyers</h4>
            </b-col>
        </b-row>

        <b-row style="margin-top:10px">
            <b-col>
                <h6>Your logo and inventory will be automatically added to the email</h6>
            </b-col>
        </b-row>

        <b-row style="margin-bottom:20px">
            <b-col>
                <h6>Scroll down to see the list of buyers your email will go to. You can manually add more email addresses below</h6>
            </b-col>
        </b-row>

        <!-- Preview Button -->
        <b-row style="margin-top:10px; margin-bottom:20px">
            <b-col>
                <b-button v-b-modal.modal-preview size="lg"
                    variant="info">Preview Email
                </b-button>
            </b-col>
        </b-row>

        <!-- Email subject -->
        <b-row>
            <b-col>
                <b-form>
                    <b-input-group prepend="Subject" class="">
                        <b-input  placeholder="Subject" v-model="emailSubject"></b-input>
                    </b-input-group>
                </b-form>
            </b-col>
        </b-row>

        <!-- Buyers-->
        <b-row>
            <b-col>
                <b-button @click="showBuyers()">Select Buyers</b-button>
            </b-col>
        </b-row>

        <!-- Email text -->
        <b-row style="margin-top:20px">
            <b-col style="height:400px">
                <wysiwyg v-model="emailHTML"  style="height:400px"
                />
            </b-col>
        </b-row>

        <!-- Send email -->
        <b-row>
            <b-col>
                <b-button  v-b-modal.modal-submit size="lg" variant="success" block style="margin-top:20px">Send Email</b-button>
                <b-modal  no-fade  scrollable id="modal-submit" title="Send This Email?" @ok="sendEmail()" ok-title="Yes, send this email" cancel-title="No, wait">
                </b-modal>
            </b-col>
        </b-row>

        <!-- Manually entered emails -->
        <h6 style="margin-top:20px">(Optional) Enter more emails, separated by commas</h6>
        <b-form-group 
            class="mb-0"
            label-for="textarea-formatter-delivery"
            description="Emails, separated by commas"
            >
            <b-form-textarea
                id="textarea-formatter-delivery"
                v-model="manualEmails"
                placeholder="Emails, separated by commas"
            ></b-form-textarea>
        </b-form-group>

        <!-- Show buyers list -->
        <b-row style="margin-top:20px">
            <b-col>
                <h4>Your email will go to:</h4>
            </b-col>
        </b-row>

        <b-row>
            <b-col>
                <table class="table table-striped" style="margin-left:50px; margin-right:50px">
                    <thead class="thead-dark">
                        <tr>
                            <th>
                                Select
                            </th>
                            <th>
                                Name
                            </th>
                            <th>
                                Address
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="theBuyer in buyersList">
                            <tr :key="theBuyer.company">
                                <!-- Button to select unselect -->
                                <td>
                                    <b-button v-if="!theBuyer.selected" variant="outline-secondary" @click="selectBuyer(theBuyer.uid)" style="height:40px; width:40px">
                                    </b-button>
                                    <b-button v-else variant="outline-secondary"  style="height:40px; width:40px" @click="unSelectBuyer(theBuyer.uid)">
                                        <font-awesome-icon icon="check-square" />
                                    </b-button>
                                </td>
                                <!-- Name -->
                                <td>{{theBuyer.company}}</td>
                                <!-- Address -->
                                <td>{{theBuyer.address}}</td>

                            </tr>
                        </template>
                    </tbody>
                </table>
            </b-col>
        </b-row>
                
    </b-container>
      
  </div>
</template>

<script>

import { mapState } from 'vuex'
const fb = require('../../firebaseConfig.js')

export default {    
    
    props: ['counties'],

    computed: {
        ...mapState(['userProfileStatus', 'userProfile', 'currentUser', 'userInventory',]),

                //Create the HTML email for preview and sending
        createHTMLEmail(){
            //Create main HTML body
            var brewerLink = "https://kegseeker.com/#/brewers/" + this.userProfile.shortName
            //Add brewery name
            var userHTML = ""

            //Add brewer logo
            if(this.userProfile.logoFileThumbnailURL){
                userHTML = userHTML + "<div style='margin-bottom:10px; display: block; margin-left: auto; margin-right: auto; width:100%'><br><a href=" + brewerLink + ' target="_blank"' + "style='text-decoration:none'>"
                userHTML = userHTML + "<img src=" + this.userProfile.logoFileThumbnailURL+ ' height="100">'
                userHTML = userHTML + '<span style="padding-left:20px; text-decoration: none; font-size:25px; color:#2e5189">' + this.userProfile.company + '</span>'
                userHTML = userHTML + "</a></div>"
            }
            //Brewery didn't have a logo
            else{
                userHTML = userHTML +  '<div style="font-size:24px; color:#2e5189">' + this.userProfile.company + ' </div>'

            }

            userHTML = userHTML + '<a href="https://www.kegseeker.com"  target="_blank" ><button style="background-color:#2e5189; border:1px solid #ffffff; border-radius:10px; color:white;  font-size:12px; cursor:pointer; padding:8px 10px;text-decoration:none; text-shadow: 0px 1px 0px #9fb8df;">Sent via Keg Seeker</button></a>'
            userHTML = userHTML + '<br><br>'
            userHTML = userHTML + this.emailHTML

            //Add brewer inventory
            var inventoryTable = '<br>'
            inventoryTable = inventoryTable + '<div style="font-size:16px; background-color:#2e5189; padding:10px; color:white; margin-top:10px">' + 'Our Inventory on Keg Seeker' + '</div>'

            //Create the inventory table
            inventoryTable = inventoryTable + "<div><table style='margin-top:10px'>"
            for (var m=0; m<this.userInventory.length; m++){
                inventoryTable = inventoryTable + "<tr>"
                //Logo
                inventoryTable = inventoryTable + '<td colspan="1">'
                //Keg Seeker logo by default
                var logoImage = 'https://res.cloudinary.com/lo4xxr5lr/image/upload/v1599083749/icons/KegSeeker_logo_small2.png'
                if(this.userInventory[m].beerLogoURL) logoImage = this.userInventory[m].beerLogoURL
                else if (this.userInventory[m].logoFileThumbnailURL) logoImage = this.userInventory[m].logoFileThumbnailURL

                inventoryTable = inventoryTable +'<a href=' + brewerLink + ' target="_blank">' +  "<img src=" + logoImage +' height="64">'
                inventoryTable = inventoryTable + '</a>'
                inventoryTable = inventoryTable + "</td>"
                //Name
                inventoryTable = inventoryTable + '<td colspan="4">'
                inventoryTable = inventoryTable + "<a href=" + brewerLink +  " target='_blank' style='font-size:17px; padding-left:20px; text-decoration: none; color:black'>" + this.userInventory[m].beerName + "</a>"
                inventoryTable = inventoryTable + "</td>"

                //End this row
                inventoryTable = inventoryTable + "</tr>"

                //Description row
                if(this.userInventory[m].description){
                    inventoryTable = inventoryTable + '<tr><td colspan="5">'
                    inventoryTable =inventoryTable + '<div style="color:#808080; font-size:12px">' + this.userInventory[m].description + '</div>'
                    inventoryTable = inventoryTable + "</td></tr>"
                }
                //Horizontal line
                inventoryTable = inventoryTable + "<tr>"
                inventoryTable = inventoryTable + '<td colspan="8">'
                inventoryTable = inventoryTable + '<hr>'
                inventoryTable = inventoryTable + '</td>'
                inventoryTable = inventoryTable + "</tr>"
                
            }
            inventoryTable = inventoryTable + "</table></div>"

            //Add table to main HTML
            userHTML = userHTML + inventoryTable

            //Add Keg Seeker logo
            userHTML = userHTML + "<div>Sent Via Keg Seeker</div>"
            userHTML = userHTML + "<div><br></div><a href='https://www.kegseeker.com/'  target='_blank' >"
            userHTML = userHTML + "<img src='https://res.cloudinary.com/lo4xxr5lr/image/upload/v1601714861/icons/KS_Blue_1_small.png'>"
            userHTML = userHTML + "</a>"

            return userHTML
        },


    },

    components: {
    },

    data() {
        return {
            emailHTML:"",
            buyersList:[],
            emailSubject:'',
            manualEmails:'',
            performingRequest:false,
        }
    },

    methods:{
        //Get buyers
        getBuyers(){
            this.buyersList = []
            var buyersArray=[]
            fb.usersCollection.where("county", "in", this.$store.state.brewerEmailsStore.countiesForEmail).where("state", "==", this.userProfile.state).where("isbrewer", "==", 0).get().then(docs => {
                docs.forEach(doc => {
                    var theBuyerData = doc.data()
                    var theBuyerId = doc.id
                    var theBuyerName = theBuyerData.company
                    var theBuyerEmail = theBuyerData.email
                    var theBuyerUid = theBuyerData.uid
                    //Create address
                    var address = theBuyerData.street1
                    if (theBuyerData.street2) address = address + ", " + theBuyerData.street2
                    address = address + ", " + theBuyerData.city + ', ' + theBuyerData.state  + " "  + theBuyerData.zip 
                    var buyerObject = {
                        company: theBuyerName,
                        email: theBuyerEmail,
                        uid: theBuyerId,
                        selected:true,
                        address:address,
                    }

                    //Add only if unsubscribeBrewerEmails != 1
                    if('unsubscribebrewer' in theBuyerData){
                        if (theBuyerData.unsubscribebrewer==1){
                            //Skip
                        }
                        //User allowed emails
                        else {
                            buyersArray.push(buyerObject)
                        }
                    }
                    //Allow email field doesn't exit
                    else{
                        buyersArray.push(buyerObject)
                    }

                    })
                }).then(res => {
                    this.buyersList = buyersArray
                    })
        },

        //Unselect a buyer
        unSelectBuyer(uid){
            const existingBuyerindex = this.buyersList.findIndex(item => item.uid === uid);
            if (existingBuyerindex>-1){
                var theBuyer = this.buyersList[existingBuyerindex]
                theBuyer.selected = false
                this.buyersList.splice(existingBuyerindex, 1, theBuyer)
            }

        },

        //Select buyer
        selectBuyer(uid){
            const existingBuyerindex = this.buyersList.findIndex(item => item.uid === uid);
            if (existingBuyerindex>-1){
                var theBuyer = this.buyersList[existingBuyerindex]
                theBuyer.selected = true
                this.buyersList.splice(existingBuyerindex, 1, theBuyer)
            }

        },

        //Preview email
        previewEmail(){

        },

        //Send the email
        sendEmail(){
            
            //Check email subject and content is entered
            if(this.emailSubject.length<4){
                this.$bvModal.show("modal-nosubject")
                return
            }

            if(this.emailHTML.length<50){
                this.$bvModal.show("modal-nocontent")
                return
            }

            var userHTML = this.createHTMLEmail

            //Create new list of toUids
            var toUids=[]
            //Show Sending Emails
            this.performingRequest = true
            for (var j=0; j<this.buyersList.length; j++){
                if (this.buyersList[j].selected) toUids.push(this.buyersList[j])
            }
            //Check if at least one buyer selected
            if (toUids.length<=0){
                this.performingRequest = false
                this.$bvModal.show("modal-nousers")
                return
            }

            //Iterate over all buyers
            try{
                for (var i=0; i<toUids.length; i++){
                    //Add unsubscribe link
                    var unbSubscribeLink = "<div><br></div><a href='https://www.kegseeker.com/#/unsubscribe/" + toUids[i].uid + "'>" + "Unsubscribe" + "</a>"
                    var finalHTML = userHTML + unbSubscribeLink
                    var mailData = {
                        to:toUids[i].email,
                        replyTo:this.currentUser.email,
                        from: this.userProfile.company +" <" + this.currentUser.email+">",
                        message:{
                            subject:this.emailSubject,
                            html:finalHTML,
                        }
                    }

                    fb.mailCollection.add(mailData)
                }
            }
            catch (err){
                this.performingRequest = false
                this.$bvModal.show("modal-senderror")
            }

            //Now iterate over manually entered emails.
            var theManualEmails = this.manualEmails.split(",")
            //Create list of manual emails with duplicates and spaces removed
            var finalManualEmails = []
            if(theManualEmails.length>0){
                for (var p=0; p<theManualEmails.length; p++){
                    var thisEmail = theManualEmails[p]
                    //Remove spaces
                    thisEmail = thisEmail.replace(' ', '')
                    thisEmail = thisEmail.toLowerCase()
                    //Check if already in array
                    const existingEmailIndex = finalManualEmails.findIndex(item => item === thisEmail);
                    if(existingEmailIndex<0) finalManualEmails.push(thisEmail)

                }
            }
            //Iterate over final emails list
            var emailsForDb = ''
            if(finalManualEmails.length>0){
                for (var k=0; k<finalManualEmails.length; k++){
                    var thisEmail = finalManualEmails[k]
                    emailsForDb = emailsForDb + thisEmail + ','
                    var mailData = {
                        to:thisEmail,
                        replyTo:this.currentUser.email,
                        from: this.userProfile.company +" <" + this.currentUser.email+">",
                        message:{
                            subject:this.emailSubject,
                            html:userHTML,
                        }
                    }

                    fb.mailCollection.add(mailData)

                }
            }

            //Add once to brewerAdvertisementEmailsCollection
            var brewerData = {
                toUids:toUids,
                manualEmails: emailsForDb,
                from: this.userProfile.company +" <" + this.currentUser.email+">",
                brewer: this.userProfile.company,
                brewerid: this.currentUser.uid,
                createdOn: new Date(),
                message:{
                    subject:this.emailSubject,
                    html:userHTML,
                }
            }
            fb.brewerAdvertisementEmailsCollection.add(brewerData)

            //Update userProfile to add manual emails
            if(emailsForDb.length>2){
                fb.usersCollection.doc(this.currentUser.uid).update({
                    manualEmails:emailsForDb,
                })
            }

            this.performingRequest = false
            
            this.$bvModal.show("modal-emailsent")
        },

        //Email sent, go back to dashboard
        emailSent(){
            this.$router.push({name:'brewerdashboard'})
        },

        //Show buyers
        showBuyers(){
            this.$router.push({name:'toemails'})
        },

    },

    mounted(){
        //Get manual emails
        if (this.userProfile.manualEmails) this.manualEmails = this.userProfile.manualEmails
        this.getBuyers()
    },
}
</script>


